import {Navigate} from "react-router-dom";
// import MainLayout from "../MainLayout";
import Loadable from "./RouteLoad/Loadable";
import {lazy} from "react";
import MainLayout from "../MainLayout";

const Dashboard = Loadable(lazy(() => import('../Dashboard/index')));
const TeamPipelines = Loadable(lazy(() => import('../TeamPipelines/index')));
const SalsePipelines = Loadable(lazy(() => import('../SalesPipeline/index')));
const UnauthorizedAccess = Loadable(lazy(() => import('../../utils/ui-components/UnauthorizedAccess')));


function TicketTrackerAuthorizedRoutes (user: any) {
    return [
        {
            path: "/",
            element: <MainLayout/>,
            children: [
                {
                    path: 'dashboard',
                    element: <Dashboard/>
                },
                {
                    path: 'team-pipelines',
                    element: <TeamPipelines/>
                },
                {
                    path: 'sales-pipelines',
                    element: <SalsePipelines/>
                },
                // {
                //     path: 'settings',
                //     element: <Configurations/>
                // },
            ]
        },
        {
            path: 'unauthorized',
            element: <UnauthorizedAccess/>
        },
        {
            path: '',
            element: <Navigate to="/dashboard"/>
        },
        {
            path: 'login',
            element: <Navigate to="/dashboard"/>
        },
        {
            path: "*",
            element: <Navigate to="/unauthorized"/>
        },
    ];
}

export default TicketTrackerAuthorizedRoutes;